<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" width="30%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="code-type-dialog-form" size="small">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="1" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="人民币" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="rmb" style="margin-bottom: 0;">
                        <ctl-number v-model="dataForm.rmb" :precision="3" :min="0" :max="999"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="美元" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="dollar" style="margin-bottom: 0;">
                        <ctl-number v-model="dataForm.dollar" :precision="3" :min="0" :max="999"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="日元" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="yen" style="margin-bottom: 0;">
                        <ctl-number v-model="dataForm.yen" :precision="3" :min="0" :max="999"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="欧元" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="euro" style="margin-bottom: 0;">
                        <ctl-number v-model="dataForm.euro" :precision="3" :min="0" :max="999"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="英镑" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="pound" style="margin-bottom: 0;">
                        <ctl-number v-model="dataForm.pound" :precision="3" :min="0" :max="999"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="日期" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="referTime" style="margin-bottom: 0;">
                        <!-- <el-date-picker v-model="dataForm.referTime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd'T'HH:mm:ss.SSS" placeholder="选择日期"> -->
                        <el-date-picker v-model="dataForm.referTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="view.visible = false">
            <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
        </el-button>
        <el-button size="small" type="primary" plain @click="dataFormSubmit()" :loading="loading">
            <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
        </el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    projectRateById,
    createRate,
    editRate,
} from "@/controller/project";
import moment from 'moment'
import CtlNumber from '@/views/common/ctl-number'
import {
    setLoading
} from "@/utils/index";
export default {
    components: {
        CtlNumber
    },
    data() {
        return {
            loading: false,
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            viewData: {},
            dataForm: {
                id: 0,
                dollar: "",
                yen: "",
                euro: "",
                pound: "",
                rmb: '',
                referTime: '',
            },
            // 开始
            dataRule: {
                name: [{
                    required: true,
                    message: "编码名称不能为空",
                    trigger: "blur",
                }, ],
                type: [{
                    required: true,
                    message: "编码类型不能为空",
                    trigger: "blur",
                }, ],
            },
        };
    },
    methods: {
        // 初始化
        init(id, projectId) {
            console.log(id, projectId)
            // debugger;
            this.dataForm.id = id || 0;
            this.dataForm.projectId = projectId;
            this.view.visible = true;
            this.loading = false;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id查汇率
                    projectRateById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                            this.dataForm.referTime = moment(this.dataForm.referTime).format("yyyy-MM-DD HH:mm:ss")
                        }
                    });
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.loading = true
            setLoading()
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let rateParams = {
                        id: this.dataForm.id || undefined,
                        projectId: this.dataForm.projectId,
                        dollar: this.dataForm.dollar,
                        yen: this.dataForm.yen,
                        euro: this.dataForm.euro,
                        pound: this.dataForm.pound,
                        rmb: this.dataForm.rmb,
                        // referTime:this.dataForm.referTime,
                        referTime: this.dataForm.referTime
                    };
                    if (this.dataForm.id) {
                        // 更新汇率表
                        editRate(rateParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshRateDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        // 创建汇率表
                        createRate(rateParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshRateDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        getStyle() {
            return 'width: 110px; text-align: right'
        },
        getStyle2() {
            // return 'text-align: center'
        }
    },
};
</script>
